import { dateWordShort } from "../../../../../../../helper/helper";
import { useEffect, useState } from "react";
import { Star } from "../../../../../../../assets/icons";
import Usefetchdata from "../../../../../../../hooks/usefetchdata";
import ApiDatabase from "server";
import TableRow from "../../../../../../../components/table/components/TableRow";
import TableCell from "../../../../../../../components/table/components/TableCell";
import { useLocation } from "react-router-dom";

const EXCLUDED_VIVIER_ID = '64e8cfd10b4f73f442432c9f';

const TbodyListVivier = ({ champsBody, navigateToFicheVivier, departments = [] }) => {
    const { userData } = Usefetchdata();
    const token = localStorage.getItem('xsrfToken');
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const selectedVivier = params.get('selectedVivier');
    const [selectedId, setSelectedId] = useState(selectedVivier);

    const departmentCounts = champsBody?.departmentCounts || {};
    const userCount = champsBody?.userCount ?? champsBody?.user_preferences?.length ?? 0;

    const isAdminFavorite = userData?._id
        && champsBody?.admin_favorites?.some((f) => f.id_user === userData._id);

    const [isFavorite, setIsFavorite] = useState(false);

    useEffect(() => {
        setIsFavorite(!!isAdminFavorite);
    }, [isAdminFavorite]);

    useEffect(() => {
        if (selectedVivier) {
            setSelectedId(selectedVivier);
            const el = document.getElementById(selectedVivier);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [selectedVivier]);

    const toggleFavorite = (e) => {
        e.stopPropagation();
        const apiCall = isFavorite ? ApiDatabase.deleteAdminVivierFavorite : ApiDatabase.postAdminVivierFavorite;
        apiCall({ token, idVivier: champsBody._id }, () => setIsFavorite(!isFavorite), console.warn);
    };

    return (
        <TableRow
            id={champsBody._id}
            itemId={champsBody._id}
            selectedId={selectedId}
            onClick={(id) => { setSelectedId(id); navigateToFicheVivier(id); }}
        >
            <TableCell position="first" stickyLeft isSelected={selectedId === champsBody._id}>
                <p className="text-sm text-gray-500">{champsBody.name}</p>
            </TableCell>
            <TableCell>
                <p className="text-sm text-gray-500">{userCount}</p>
            </TableCell>
            {departments.map((dept) => (
                <TableCell key={dept}>
                    <p className="text-sm text-gray-500">{departmentCounts[dept] || 0}</p>
                </TableCell>
            ))}
            <TableCell>
                <p className="text-sm text-gray-500">{dateWordShort(champsBody.createdAt)}</p>
            </TableCell>
            <TableCell>
                <p className="text-sm text-gray-500">{dateWordShort(champsBody.updatedAt)}</p>
            </TableCell>
            <TableCell position="last">
                {champsBody._id !== EXCLUDED_VIVIER_ID && (
                    <button
                        className="w-8 h-8 flex justify-center items-center"
                        onClick={toggleFavorite}
                    >
                        <Star wh={20} color={isFavorite ? '#FF9600' : '#F3F4F6'} />
                    </button>
                )}
            </TableCell>
        </TableRow>
    );
};

export default TbodyListVivier;